import React from "react";
import { useLocation, useOutlet } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import OnboardingHeader from "@/components/OnboardingHeader";
import { collectOnboardingRoutes } from "@/navigation/onboardingRouter";

import "@/assets/css/transition-style.css";

const OnboardingLayout = () => {
  const location = useLocation();
  const currentOutlet = useOutlet();

  const { nodeRef } =
    collectOnboardingRoutes.find(route =>
      location.pathname.endsWith(route.path),
    ) ?? {};

  const animationClassNames =
    location?.state?.direction === "BACKWARDS"
      ? "slide-backward"
      : "slide-forward";

  return (
    <>
      <OnboardingHeader />
      <TransitionGroup
        childFactory={child =>
          React.cloneElement(child, {
            classNames: animationClassNames,
          })
        }>
        <CSSTransition
          key={location.pathname}
          nodeRef={nodeRef}
          timeout={400}
          classNames={animationClassNames}>
          <div ref={nodeRef}>{currentOutlet}</div>
        </CSSTransition>
      </TransitionGroup>
    </>
  );
};

export default OnboardingLayout;
